// extracted by mini-css-extract-plugin
export default {"wrapper":"Advantages_wrapper__wcipu","container":"Advantages_container__8Bbl3","block":"Advantages_block__PlDAL"};